import axios from 'axios';

const generalInstance = axios.create({
  baseURL: '/api/auth/login'
});

export default generalInstance;
